import createStore, { createStoreHooks } from "./store"
import * as reducer from './dashboard.reducer'

export const Actions = reducer.Actions
export const Dialogs = reducer.Dialogs

export const Triggers = {
    ProjectList: "project_list",
    RefreshProjectList: "refresh_project_list",
    CompileStatus: "compile_status",    
    GetQueuedProjects: "get_queued_projects",
    GetReactFlowViewport: "get_react_flow_viewport",
    SetActiveProject: "set_active_project",
    RefreshAccountPlan: "refresh_account_plan",
    RefreshTheme: "refresh_theme",
    RefreshUserInfo: "refresh_user_info"
}

// boilerplate below for DX
const util = createStoreHooks()

export const useSelector = util.useSelector
export const useDispatch = util.useDispatch

export const useTrigger = util.useTrigger
export const useRegisterTrigger = util.useRegisterTrigger


export default createStore(reducer)
